export enum SearchCriteria {
    AccountNumber,
    CustomerName,
    CustomerNumber,
}

export class CustomerFilter {
    public searchValue = '';

    public selectedCriteria: SearchCriteria = SearchCriteria.CustomerName;
}
